<script setup lang="ts">
import { ArrowRight, Clock, Mail, MapPin } from "lucide-vue-next";
import PublicPageLayout from "~/components/public/PublicPageLayout.vue";

const { t } = useI18n();

const { canonicalUrl, currentLocale } = useLocalizedSeoLinks("/contacts");

useSeoMeta({
  title: () => t("public_pages.contacts.seo.title"),
  description: () => t("public_pages.contacts.seo.description"),
  robots: "index, follow",
  ogTitle: () => t("public_pages.contacts.seo.title"),
  ogDescription: () => t("public_pages.contacts.seo.description"),
  ogType: "website",
  ogUrl: () => canonicalUrl.value,
  ogLocale: () => currentLocale.value.ogLocale,
  ogSiteName: "Senta.lt",
});
</script>

<template>
  <PublicPageLayout
    :eyebrow="$t('footer.contacts.header')"
    :title="$t('public_pages.contacts.title')"
    :description="$t('public_pages.contacts.description')"
  >
    <div class="grid gap-3 sm:grid-cols-3 sm:gap-4">
      <a
        href="mailto:info@senta.lt"
        class="group rounded-2xl bg-primary p-5 text-white transition hover:-translate-y-0.5 hover:shadow-md sm:p-6"
      >
        <div
          class="flex size-10 items-center justify-center rounded-full bg-white/10"
        >
          <Mail class="size-5" />
        </div>

        <h2 class="mt-5 text-lg font-bold sm:text-xl">
          {{ $t("public_pages.contacts.email_title") }}
        </h2>
        <p
          class="mt-1.5 text-sm text-white/75 transition group-hover:text-white sm:text-base"
        >
          info@senta.lt
        </p>
      </a>

      <div class="rounded-2xl bg-primary p-5 text-white sm:p-6">
        <div
          class="flex size-10 items-center justify-center rounded-full bg-white/10"
        >
          <Clock class="size-5" />
        </div>

        <h2 class="mt-5 text-lg font-bold sm:text-xl">
          {{ $t("public_pages.contacts.hours_title") }}
        </h2>
        <p class="mt-1.5 text-sm text-white/75 sm:text-base">
          {{ $t("footer.contacts.working_hours") }}
        </p>
      </div>

      <div class="rounded-2xl bg-primary p-5 text-white sm:p-6">
        <div
          class="flex size-10 items-center justify-center rounded-full bg-white/10"
        >
          <MapPin class="size-5" />
        </div>

        <h2 class="mt-5 text-lg font-bold sm:text-xl">
          {{ $t("public_pages.contacts.location_title") }}
        </h2>
        <p class="mt-1.5 text-sm text-white/75 sm:text-base">
          {{ $t("public_pages.contacts.location_value") }}
        </p>
      </div>
    </div>

    <section class="mt-14 max-w-[760px] sm:mt-16">
      <h2
        class="text-3xl font-bold tracking-tight text-app-text sm:text-[34px]"
      >
        {{ $t("public_pages.contacts.help_title") }}
      </h2>

      <p class="mt-4 max-w-[700px] text-base leading-7 text-app-muted">
        {{ $t("public_pages.contacts.help_description") }}
      </p>

      <a
        href="mailto:info@senta.lt"
        class="mt-7 inline-flex h-12 items-center justify-center gap-2 rounded-full bg-primary px-6 text-sm font-bold text-white transition hover:opacity-90"
      >
        {{ $t("public_pages.contacts.email_title") }}
        <ArrowRight class="size-4" />
      </a>
    </section>
  </PublicPageLayout>
</template>
